<template>
  <div class="bg_gray text-center" style="padding-bottom:20px;">
    <div class="result_wrap">
      <van-icon :name="result_icon" />
      <div class="text-center msg">{{result_msg}}</div>
      <div class="content"
           v-for="(order_item,index) in payment_info.orders" :key="index"
           v-if="method==='payment'">
        <p v-if="payment_info.orders.length !== 0">订单编号：{{order_item.order_sn}}</p>
        <p v-if="payment_info.orders.length !== 0">支付金额：¥{{order_item.order_amount}}</p>
        <p v-if="payment_info.orders.length !== 0">支付方式：{{order_item.payment_type_text}}</p>
        <p v-if="payment_info.orders.length !== 0">支付编号：{{order_item.payment_sn}}</p>
        <p v-if="payment_info.orders.length !== 0">{{table_col_name}}：{{order_item.payed_auto_time}}</p>
        <p v-if="payment_info.orders.length !== 0">支付状态：{{order_item.payment_state_text}}</p>
      </div>
      <div class="content" v-if="method==='single'">
        <p>订单编号：{{order_info.order_sn}}</p>
        <p>下单时间：{{order_info.created_at_local}}</p>
        <p>订单状态：{{order_info.state_text}}</p>
      </div>
    </div>
    <div>
      <van-button type="danger" @click="resultBtnAction" style="margin-right:10px">{{ btn_text }}</van-button>
      <van-button type="default"
                  v-if="method==='payment' && is_payment_offline"
                  @click="reselectPaymentMethod">重新选择支付方式</van-button>
    </div>
  </div>
</template>

<script>
  import {detailOrder, fmtUserOrderInfo} from 'api/settlement/order/user'
  import { db_time_to_local_fmt } from 'utils/timeutils'
  import { showMessage } from 'api/base/mobile/message'
  import {fmtPaymentInfo} from 'api/settlement/payment/admin'
  import {queryPayment, reselectPreparePayment} from 'api/settlement/payment/user'
  export default {
    data() {
      return {
        method: 'single',
        btn_text: '查看我的订单',
        btn_go_url: '/mobile/center/order',
        result_icon: '',
        result_msg: '',
        order_uuid: '',
        order_info: {},
        payment_uuid: '',
        is_payment_offline: false,
        payment_info: {
            orders: []
        },
        table_col_name: '',
        dashboard_base_url: null,
      }
    },
    created() {

      const that = this;

      if (this.$route.params.method != undefined && this.$route.params.method.length > 0) {
        this.method = this.$route.params.method;
      }

      if (!['single', 'payment'].includes(this.method)) {
        showMessage('非法操作').then(()=>{
          that.goPath('/mobile');
        })
        return;
      }

      if (this.$route.params.order_uuid != undefined) {

        switch (this.method) {
          case 'single': { // 单个订单结果
            this.order_uuid = this.$route.params.order_uuid;
            this.loadOrderInfo();
          } break;
          case 'payment': { // 支付结果
            this.payment_uuid = this.$route.params.order_uuid;
            this.loadPaymentInfo();
          } break;
        }

      }

    },
    mounted() {
      this.$emit('update:isShowHeader', true);
    },
    methods: {
      async loadOrderInfo(){

        const that = this;

        this.$emit('update:isShowOverlay', true);
        await detailOrder(this.order_uuid).then(result => {

          if (result.succeed) {

            that.dashboard_base_url = result.dashboard_base_url;

            let filled_order_info = fmtUserOrderInfo(result.order_info);

            console.log(filled_order_info);

            that.order_info = filled_order_info;

            switch (filled_order_info.state_text) {
              case '已取消' : {
                that.result_icon = 'clear';
                that.result_msg = '订单已取消，使用的优惠券已返还！';
              } break;
              case '已关闭' : {
                that.result_icon = 'clear';
                that.result_msg = '订单因逾期未支付已自动关闭，订单中使用的优惠券已返还！';
              } break;
            }


            that.btn_go_url = '/mobile/center/order';
            that.btn_text = '查看我的订单';

          } else {

              window.location.href = '/mobile/center/order/';

//            this.$dialog.alert({
//              title: '提示',
//              message: `${result.error_msg}`,
//            }).then(() => {
//              that.goPath('/course/list');
//            });

          }

          this.$emit('update:isShowOverlay', false);

        }).catch(err => {
//          showMessage(err);

          window.location.href = '/mobile/home/';

          this.$emit('update:isShowOverlay', false);
        });

      },
      async loadPaymentInfo(){

        const that = this;

        await queryPayment(this.payment_uuid).then(result => {

          if (result.succeed) {

            let payment_instance = fmtPaymentInfo(result.instance);
            let vip_order = false;

            payment_instance.orders.forEach(item=>{

                if(item.type === 2){
                    vip_order = true;
                }

                item.payment_type_text = payment_instance.type_text;
                item.payment_sn = payment_instance.payment_sn;
                item.payment_state_text = payment_instance.state_text;
                item.payed_auto_time = item.payed_at ? db_time_to_local_fmt(item.payed_at) : db_time_to_local_fmt(item.created_at) ;
            });

            console.log(payment_instance);


            switch(payment_instance.state_text){
              case '已收款' : {

                that.payment_info = payment_instance;

                that.result_icon = 'checked';
                that.result_msg = '支付成功，订单已完成！';

                if (vip_order) {
                  that.btn_go_url = '/mobile/center/card/vip_card';
                  that.btn_text = '查看我的会员卡';
                } else {
                  that.btn_go_url = '/mobile/center/course';
                  that.btn_text = '查看我的课程';
                }


                that.table_col_name = '支付时间';

              } break;
              case '待收款' : {

                that.payment_info = payment_instance;

                that.result_icon = 'checked';
                that.result_msg = '提交成功，请联系客服完成付款！';

                that.btn_go_url = '/mobile/center/order';
                that.btn_text = '查看我的订单';

                that.table_col_name = '下单时间';

                that.is_payment_offline = true;

              } break;
              default: {
                showMessage('暂不支持当前操作').then(()=>{
                  that.goPath('/mobile');
                })
              }
                break;
            }


          } else {
            window.location.href = '/mobile/center/order/';
          }

        }).catch(err => {
          window.location.href = '/mobile/center/order/';
        });
      },

      async reselectPaymentMethod(){

        const that = this;
        await reselectPreparePayment(this.payment_uuid).then(result => {

          if (result.succeed) {

            switch (result.payment_method) {
              case 'single': {
                that.goPath(`/mobile/order/pay/${result.order_uuid_list[0]}/`)
              }
                break;
              case 'mixed': {
                that.goPath(`/mobile/order/pay/mixed/${result.confirm_key}/`)
              }
                break;
            }


          } else {
            showMessage(result.error_msg)
          }

        }).catch(err => {

          showMessage(err);

        });
      },

      resultBtnAction(){
        this.goPath(this.btn_go_url);
      },
      goPath(path) {
        this.$router.push(path);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .result_wrap {
    background:#fff;
    padding:40px 10px 20px 10px;
    margin-bottom:20px;
    .van-icon {
      font-size:46px;
      margin-bottom:20px;
      &.van-icon-checked {
        color:#52c41a;
      }
      &.van-icon-clear {
        color:#f51c21;
      }
    }
    .msg {
      font-size:16px;
      margin-bottom:30px;
    }
    .content {
      background:#f8f8f8;
      padding:15px;
      text-align:left;
      margin-bottom:10px;
      p {
        margin-top:15px;
        margin-bottom:0;
        &:first-child {
          margin-top:0;
        }
      }
    }
  }



  :deep(.el-result) {
    padding-top:80px;
    .icon-error {
      fill: #f51c21;
    }
    .el-result__icon {
      svg {
        width:80px;
        height:80px;
      }
    }
    .el-result__title {
      p {
        color:#666;
      }
    }
    .el-result__extra {
      width:100%;
      margin-top:50px;
      .el-button {
        margin-top:80px;
      }
    }
  }
  .code_kf {
    width:150px;
    background:#f2f2f2;
    padding:10px;
    margin:25px auto 0;
    > img {
      width:100%;
      margin-bottom:10px;
    }
    > span {
      color:#3fb3e0;
    }
  }
</style>
